import React, { useState, useCallback, useEffect } from 'react'
import { useEmblaCarousel } from 'embla-carousel-react'
import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import Box from '@components/Box'
import { SH2 } from '@components/Typography'
import { xl, md } from '@styles/variables/breakpoints'
import { TBenefit } from '@api/Form'
import Card from './Card'

export interface IBenefits {
  heading: string
  cards: TBenefit[]
}

interface IPropsSDot {
  active: boolean
  color: string
}

const SDot = styled.button<IPropsSDot>`
  display: block;
  border: none;
  background: #ccc;
  width: 6px;
  height: 6px;
  padding: 0;
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0 2px;
  border-radius: 100%;
  ${({ active, color }) => (active ? `background: ${color}` : '')}
`

interface IDotButton {
  selected: boolean
  onClick: () => void
  color: string
}
export const DotButton: React.FC<IDotButton> = ({ selected, onClick, color }) => (
  <SDot active={selected} type="button" onClick={onClick} color={color} />
)

const Benefits: React.FC<IBenefits> = ({ heading, cards }) => {
  const isLg = useMediaQuery({ minWidth: xl })
  const isMd = useMediaQuery({ maxWidth: md - 1 })

  const sliderSettings = {
    loop: false,
    slidesToScroll: isLg ? 4 : 1,
    containScroll: ' ',
    align: 'start',
    speed: 20,
  }
  const [Slider, slider] = useEmblaCarousel(sliderSettings)
  const [selectedIndex, setSelectedIndex] = useState<number>(0)

  const scrollTo = useCallback((index: number) => slider && slider.scrollTo(index), [slider])

  const onSelect = useCallback(() => {
    if (!slider) return
    setSelectedIndex(slider.selectedScrollSnap())
  }, [slider])

  useEffect(() => {
    if (!slider) return
    slider.on('select', onSelect)
    onSelect()
  }, [slider, onSelect])

  useEffect(() => slider && slider.reInit(sliderSettings), [slider, isLg])

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={{ _: '20px', xl: '24px' }}>
        <SH2>{heading}</SH2>
      </Box>
      <Slider className="slider">
        <Box display="flex" ml="-20px">
          {cards.map((card, i) => {
            return <Card key={i} {...card} />
          })}
        </Box>
      </Slider>
      {isMd && (
        <Box display="flex" mt="20px" justifyContent="center">
          {cards.map((_, index) => (
            <DotButton
              key={index}
              selected={index === selectedIndex}
              color={'#21a038'}
              onClick={() => scrollTo(index)}
            />
          ))}
        </Box>
      )}
    </>
  )
}

export default Benefits
